
  import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Global error logging to capture stack traces for runtime errors and unhandled rejections.
if (typeof window !== 'undefined') {
  window.addEventListener('error', (e: ErrorEvent) => {
    try {
      // Log minimal info and stack if available
      console.error('GlobalError:', e.error?.stack || e.message, {
        filename: e.filename,
        lineno: e.lineno,
        colno: e.colno,
      });
    } catch (err) {
      console.error('Error in global error handler', err);
    }
  });

  window.addEventListener('unhandledrejection', (ev: PromiseRejectionEvent) => {
    try {
      console.error('UnhandledRejection:', (ev.reason && (ev.reason.stack || ev.reason)) || ev.reason);
    } catch (err) {
      console.error('Error in unhandledrejection handler', err);
    }
  });
}

  createRoot(document.getElementById("root")!).render(<App />);
  